import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AppContext from '../../../context/AppContext';
import Checkbox from '../../../shared/Checkbox';
import Item from '../../../shared/TechSkills/Item';
import AddItem from '../../../shared/TechSkills/AddItem';
import DragNDropList from '../../../shared/DragNDropList';
import config from '../../../config';

const AndroidTechnologiesTab = ({ data, onChange }) => {

  const context = useContext(AppContext);
  const { dispatch } = context;
  const { t } = useTranslation('leftSidebar');

  useEffect(() => {
    if (!('androidTechnologies' in data)) {
      dispatch({
        type: 'migrate_section',
        payload: {
          key: 'androidTechnologies',
          value: {
            enable: false,
            heading: 'Android Technologies',
            items: [],
          },
        },
      });
    }
  }, [data, dispatch]);

  return (
    'androidTechnologies' in data && (
      <>
        <div className="mb23 flex justify-between items-center">
          <div className="title_tab">{t('androidTechnologies.title.label')}</div>

          <div className="col-span-1">
            <Checkbox
              checked={data.androidTechnologies.enable}
              onChange={v => onChange('data.androidTechnologies.enable', v)}
            />
          </div>
        </div>

        <hr className="my-6" />

        <DragNDropList
          data={data}
          dispatch={dispatch}
          onChange={onChange}
          type="androidTechnologies"
        >
          {data.androidTechnologies.items.map((x, index) => (
            <Item
              item={x}
              key={x.id}
              index={index}
              onChange={onChange}
              dispatch={dispatch}
              first={index === 0}
              last={index === data.androidTechnologies.items.length - 1}
              type='androidTechnologies'
              idTab={config.TECH_SKILLS_TABS.androidTechnologies}
            />
          ))}          
        </DragNDropList>


        <AddItem heading={data.androidTechnologies.heading} dispatch={dispatch} type='androidTechnologies' idTab={config.TECH_SKILLS_TABS.androidTechnologies} />
      </>
    )
  );
};

export default AndroidTechnologiesTab;
